import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-752ffb80"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "footer",
  class: "flex"
}
const _hoisted_2 = { class: "footer-content flex flex-column py-s6" }
const _hoisted_3 = { class: "flex justify-content-between align-items-start" }
const _hoisted_4 = { class: "flex align-items-end w-full flex-wrap xl:flex-nowrap row-gap-4" }
const _hoisted_5 = { class: "w-6 xl:w-4 xl:flex-order-0" }
const _hoisted_6 = { class: "w-6 xl:w-4 xl:flex-order-2" }
const _hoisted_7 = { class: "w-12 xl:w-4 xl:flex-order-1" }
const _hoisted_8 = {
  key: 1,
  class: "flex justify-content-center"
}

import FooterMenu from './FooterMenu.vue';
import CommunityIcons from './CommunityIcons.vue';
import Copyright from './Copyright.vue';
// import LanguageSelect from './LanguageSelect';
import InfoPanel from './InfoPanel.vue';
import { useStore } from 'vuex';
import ThemeSwitch from '@/components/ThemeSwitch.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'Footer',
  setup(__props) {

const { state } = useStore();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (!_unref(state).layout.isMobile)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(FooterMenu, { class: "w-12 sm:w-auto xl:min-w-max" }),
              _createVNode(InfoPanel)
            ]),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createVNode(ThemeSwitch)
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createVNode(CommunityIcons)
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createVNode(Copyright)
              ])
            ])
          ], 64))
        : (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createVNode(Copyright)
          ]))
    ])
  ]))
}
}

})